import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LacertaBackgroundImageDirective } from './background-image.directive';
import { HeroComponent } from './hero.component';

@NgModule({
  declarations: [LacertaBackgroundImageDirective, HeroComponent],
  exports: [LacertaBackgroundImageDirective, HeroComponent],
  imports: [CommonModule],
})
export class LacertaImageModule {}
